import { useMemo } from 'react';
import { Division, FlightRoomUser } from '@connect-x-app/shared-domain-models';
import { UserUtil } from '@connect-x-app/shared-utils';

export type FlightRoomUserWithName = FlightRoomUser & {
  division: Division;
  name: string | null;
};

export const useEnrichedFlightRoomUsers = (flightroomUsers: FlightRoomUser[]): FlightRoomUserWithName[] => {
  return useMemo(() => {
    return flightroomUsers.map(flightroomUser => {
      return {
        ...flightroomUser,
        division: UserUtil.getDivision(flightroomUser.jobTitle),
        name: UserUtil.getFullName(flightroomUser) || null,
      };
    });
  }, [flightroomUsers]);
};
